import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header2 from "../components/header/Header03";
import MobileHeader from "../components/header/MobileHeader";
import Footer from "../components/footer";
import Blog01 from "../components/blog/Blog01";
import dataBlog from "../assets/fakeData/dataBlog";
import { Link } from "react-router-dom";
import Gotop from "../components/gotop";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../assets/images/logo.png";
import httpService from "../services/httpService";
import { getToken, redirectInternal } from "../services/authService";

const NewsSingle = () => {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);
  const [newsData, setNewsData] = useState(null);
  const [relatedArticles, setRelatedArticles] = useState([]);
  const [feedbackMsg, setFeedbackMsg] = useState("");
  const [pageLoader, setPageLoader] = useState(true);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  const getNewsBySlug = async (slug) => {
    try {
      const res = await httpService.get(`/news/slug/${slug}`);
      setNewsData(res.data.data);

      await getRelatedNews(res.data.data.category, res.data.data._id);
      setPageLoader(false);
    } catch (error) {
      setPageLoader(false);
    }
  };

  const getSubById = async () => {
    try {
      const res = await httpService.get("/subscription/user-subscriptions");

      if (res.status === 200 && res.data.data === null) {
        localStorage.setItem("current-page", window.location.pathname);
        return redirectInternal("/pricing");
      };

      if (res.data.data?.paymentStatus !== "true") {
        localStorage.setItem("current-page", window.location.pathname);
        return redirectInternal("/pricing");
      }
    } catch (error) { }
  };

  const checkForTokenAndPrice = () => {
    const userAuth = getToken();

    if (userAuth === null || userAuth === undefined || !userAuth) {
      localStorage.setItem("current-page", window.location.pathname);
      return redirectInternal("/login");
    };

    // check user pricing: for now the goal is to get users in, so free access for now
    // getSubById();
  };

  const slug = window.location.pathname.split("/").pop();

  useEffect(() => {
    checkForTokenAndPrice()
    getNewsBySlug(slug);
  }, [slug]);


  const getRelatedNews = async (category, newsId) => {
    try {
      const res = await httpService.get(`news/related/news?category=${category}&excludeNewsId=${newsId}&limit=3`);

      setRelatedArticles(res.data.data);

    } catch (err) { }
  };

  const handleFeedback = async (e, feedback) => {
    e.preventDefault();

    try {
      setFeedbackMsg("");
      const res = await httpService.patch(`/news/${slug}/feedback?type=${feedback ? "helpful" : "not_helpful"}`, {});

      if (res.status === 200) {
        setFeedbackMsg("Thank you! Feedback sent successfully!");
      };
    } catch (error) { }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };


  let shareUrl = window.location.href;

  function formatSlug(slug) {
    return slug
      .split("-")
      .map(word =>
        word.toUpperCase() === "UK"
          ? "UK"
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(" ");
  };

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{`UKICNEWS - ${newsData?.title}`}</title>
          <meta
            name="description"
            content={newsData?.description || "Stay updated with UK immigration news, visa changes, sponsorship jobs, and clear policy explanation for Business, Family Sponsorship, study, work, visit, ILR and more. UKICNEWS delivers trusted and timely immigration updates."}
          />
          <link rel="canonical" href={shareUrl} />

          {/* Open Graph (Facebook / LinkedIn preview) */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content={`UKICNEWS | ${newsData?.title}`} />
          <meta
            property="og:description"
            content={newsData?.description || "Get reliable UK immigration updates, visa news, and sponsorship job opportunities."}
          />
          <meta property="og:url" content={shareUrl} />
          <meta property="og:image" content={newsData?.bannerImage || "https://www.ukicnews.com/preview.png"} />

          {/* Twitter preview */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={`UKICNEWS | ${newsData?.title}`} />
          <meta
            name="twitter:description"
            content={newsData?.description || "Stay updated with UK immigration rules and sponsorship jobs."}
          />
          <meta name="twitter:image" content={newsData?.bannerImage || "https://www.ukicnews.com/preview.png"} />
        </Helmet>
      </HelmetProvider>
      <MobileHeader handleMobile={handleMobile} />
      <Header2 clname="actBlog4" handleMobile={handleMobile} />
      {pageLoader ? (<section className="account-section">
        <div className="tf-container">
          <div className="row">
            <div className="wd-form-login">
              <h4>Loading article...</h4>
            </div>
          </div>
        </div>
      </section>) : (<><section className="blog-detail-section">
        <div className="tf-container">
          <div className="wrap-blog-detail blog-detail blog-detail-side-bar-content">
            <div className="widget-blog-1">
              <div className="content">
                <span className="sub-title">{newsData?.category && formatSlug(newsData?.category)}</span>
                <h3 className="main-heading">
                  {newsData?.title}
                </h3>
                <ul className="meta">
                  <li className="time">
                    <span className="icon-calendar"></span> {formatDate(newsData?.createdAt)}
                  </li>
                </ul>
              </div>
              <div className="image">
                <img
                  src={newsData ? newsData.bannerImage : require("../assets/images/blog/blog-detail-01.jpg")}
                  alt=""
                />
              </div>
            </div>
            <div className="divider mt-3">
              <style>
                {`
      .divider h1 { margin-top: 1em; font-size: 1.5rem; margin-bottom: 1em; }
      .divider h2 { font-size: 1.25rem; margin-bottom: 1em; }
      .divider h3 { font-size: 1.1rem; margin-bottom: 1em;}
      .divider h4, .divider h5, .divider h6 { font-size: 1rem; margin-bottom: 1em; }
      .divider p {    margin-bottom: 1em; line-height: 1.8; }
    `}
              </style>
              <div
                dangerouslySetInnerHTML={{ __html: newsData?.content }}
                style={{ fontSize: "1rem", lineHeight: "1.8", marginBottom: "1em" }}
              />
            </div>

            <div className="tag-social">
              <div className="widget-popular-tags">
                <span className="main-title">Tags:</span>
                <ul className="widget-popular-tags-wrap">
                  {newsData?.tags?.map((tag, index) => (
                    <li key={index} className="widget-popular-tags-item">
                      <Link to="#">{tag}</Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="wd-social d-flex aln-center">
                <span>Share this post:</span>
                <ul className="list-social d-flex aln-center">
                  <li><a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon-facebook"></i>
                  </a></li>
                  <li><a
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon-linkedin2"></i>
                  </a>
                  </li>
                  <li>
                    <a
                      href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${`Latest UK Immigration News: ${newsData?.title}`}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="icon-twitter"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="wd-form-rating">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-rating-heading mb-3">
                    <h3>Did you find this information helpful?</h3>
                  </div>
                </div>
                <br />
                {feedbackMsg ? (<div className="col-lg-12">
                  <div className="form-rating-heading mt-3">
                    <p>{feedbackMsg}</p>
                  </div>
                </div>) : (<div className="col-lg-12 mt-3">
                  <button className="tf-btn-submit style-2" onClick={(e) => handleFeedback(e, true)}>
                    Yes
                  </button>
                  {" "}
                  <button className="tf-btn-submit style-2" onClick={(e) => handleFeedback(e, false)}>
                    No
                  </button>
                </div>)}

              </div>
            </div>
          </div>
        </div>
      </section>
        <Blog01 data={relatedArticles} className="inner-news-section" /></>)}
      <Footer />
      <Gotop />
    </>
  );
};

export default NewsSingle;
